<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:24:36+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2019-06-07T13:03:25+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">
  <b-navbar
    id="top-navbar"
    toggleable="md"
    type="dark"
    variant="primary"
    fixed="top">

    <b-container>

      <!-- NOTE: VueBootstrap: "to" instead of "href" will use <router-link> -->
      <b-navbar-brand to="/">
        <!-- image to use on narrow mobile screen -->
        <lzimg class="d-md-block d-lg-none d-xl-none" alt="[Q]" src="@/assets/img/logo/Qrespi-logo-white.svg" height="28"/>
        <!-- image to use on wide screens -->
        <lzimg class="d-none d-lg-block d-xl-block" alt="[Qrespi]" src="@/assets/img/logo/Qrespi-logo-white.svg" height="28"/>
      </b-navbar-brand>
      <b-nav-text>
        <social-share-button
          :hashtags="$t('title.hashtags')"
          :title="$t('title.slogan')"
          :description="$t('title.subtitle')"
          :quote="$t('intro.1.payload')"
          class="pl-4 pr-4"/>
      </b-nav-text>
      <!-- the hamburger menu on xs screens -->
      <b-navbar-toggle target="nav_collapse" />

      <b-collapse id="nav_collapse" is-nav >

        <!-- Left aligned nav items -->
        <b-navbar-nav/>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">

          <!-- ** Puck** -->
          <b-nav-item :to="{name:'puck'}" >{{ $t('puck.label') }}</b-nav-item>

          <!-- ** Prices ** -->
          <b-nav-item :to="{name:'puck_prices'}" >{{ $t('prices.label') }}</b-nav-item>

          <!-- ** Services ** -->
          <b-nav-item-dropdown :text="$t('solutions.label')" right>
            <b-dropdown-item :to="{name:'consumer_sol'}">{{ $t('solutions.consumer.label') }}</b-dropdown-item>
            <b-dropdown-item :to="{name:'business_sol'}">{{ $t('solutions.business.label') }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <!-- ** Resources **  -->
          <b-nav-item-dropdown :text="$t('resources.label')" right>
            <b-dropdown-item :to="{name:'about'}">{{ $t('about_us.label') }}</b-dropdown-item>
            <b-dropdown-item :to="{name:'career'}">{{ $t('career.label') }}</b-dropdown-item>
            <hr>
            <b-dropdown-item :to="{name:'download'}">{{ $t('resources.docs.label') }}</b-dropdown-item>
            <b-dropdown-item :to="{name:'technology'}">{{ $t('technology.label') }}</b-dropdown-item>
            <b-dropdown-item :to="{name:'faq'}">{{ $t('resources.faq.label') }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item :to="{name:'blog'}">{{ $t('resources.blog.label') }}</b-nav-item>
          <!-- contact v-scroll-to="'#contact'" -->
          <b-nav-item to="/#contact" >{{ $t('contact.label') }}</b-nav-item>

          <!-- Preorder button: small & float right. NOTE: .nav-item must wrap .nav-link to catch dropdown event -->
          <b-nav-item :to="{name:'puck_order'}">
            <b-button
              id="pre-order-button"
              size="sm"
              variant="secondary"
              class="ml-auto nav-link">
              {{ $t('preorderpuck.label') }}
            </b-button>
          </b-nav-item>

          <!-- helpers -->
          <locale-switcher id="locale-switch" :locales="['en', 'nl']" :show-full="true" class="pl-1"/>
          <currency-switcher id="currency-switch" :currencies="['eur', 'usd', 'gbp', 'cad', 'aud']" :show-full="true"/>
        </b-navbar-nav>

      </b-collapse>
    </b-container>

  </b-navbar>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style lang="scss">

  #top-navbar {
    padding-top: 4px;
    padding-bottom: 1px;
  }

  #top-navbar,
  #footer-bar {
    // the looks of the bar itself; little shadow line below
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3) !important;
    -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3) !important;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3) !important;

    // active button high light
    .nav-link.active {
      button {
        background: none;
      }
    }
    // preorder button, on dropdown move right
    .nav-link {
      text-align: right;
    }
    // dropdown a bit looks change
    .dropdown-menu {
      font-size: 0.9em;
      padding: 2px;
      .dropdown-item {
        &.is-current{
          background-color: $primaryHighlight;
          cursor:  default;
        }
      }
      .dropdown-item:hover {
        background-color: $secondaryMedium;
        color: $primaryWhite;
      }
      hr {
        margin: 0;
      }
    }
    #pre-order-button {
      margin-top: -6px;
      padding: 0.2rem 0.5rem 0.25rem;
    }

    // Locale and Currency Drops Downs
    #locale-switch,
    #currency-switch {
     display: inline-block;
     a {
       padding-right: 0;
     }
    }

    // nav button collapse
    .navbar-toggler[aria-expanded="true"] {
      // remove dotted line around link on FireFox
      outline: 0;

      /* Rotate to ||| */
      .navbar-toggler-icon {
        animation:         rotate-button .5s forwards; /* CSS3 */
        -moz-animation:    rotate-button .5s forwards; /* Firefox */
        -webkit-animation: rotate-button .5s forwards; /* Webkit */
      }
      @keyframes rotate-button { /* CSS3 */
        0%   { transform: rotate(0);    }
        100% { transform: rotate(90deg); }
      }
    }
  }

</style>
